import React from 'react';
import PropTypes from 'prop-types';
import { InputGroup } from 'react-bootstrap';
import { FaIcon } from '../../../shared/components';

const CalendarInput = ({ onClick, value }) => {
  return (
    <InputGroup>
      <input
        className="date-picker-input"
        readOnly={true}
        defaultValue={value}
        onClick={onClick}
      />
      <span
        className="input-group-addon"
        style={{ background: 'white', cursor: 'pointer' }}
        onClick={onClick}
      >
        <FaIcon icon="calendar-alt" style={{ color: '#4F4F4F' }} />
      </span>
    </InputGroup>
  );
};

CalendarInput.propTypes = {
  onClick: PropTypes.func,
  value: PropTypes.string,
};

export default CalendarInput;
